import { connect } from 'react-redux';
import RegionRestrictionList from '../RegionRestrictionList';
import { addRestriction, removeRestriction } from '../../actions/reduxActions/flowConfigurations';

// Pass flowId to restriction actions
export default flowId => connect(null, dispatch => ({
    addRestriction: ({ restrictionName, restrictionRegionName, regionCode }) => dispatch(
        addRestriction({ flowId, restrictionName, restrictionRegionName, regionCode }),
    ),
    removeRestriction: ({ restrictionName, restrictionRegionName, regionCode }) => dispatch(
        removeRestriction({ flowId, restrictionName, restrictionRegionName, regionCode }),
    ),
}))(RegionRestrictionList);
